module.exports = __webpack_public_path__ + "img/berryGlow3.7194c900.jpg";